import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import { useNavigate, NavLink } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import { useContext, useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { useParams} from 'react-router-dom';
import { useLocation  } from 'react-router-dom';

const propertyValueRanges = [
    { min: 0, max: 80000, label: '£0 - £80,000' },
    { min: 80001, max: 100000, label: '£80,001 - £100,000' },
    { min: 100001, max: 150000, label: '£100,001 - £150,000' },
    { min: 150001, max: 200000, label: '£150,001 - £200,000' },
    { min: 200001, max: 250000, label: '£200,001 - £250,000' },
    { min: 250001, max: 300000, label: '£250,001 - £300,000' },
    { min: 300001, max: 350000, label: '£300,001 - £350,000' },
    { min: 350001, max: 400000, label: '£350,001 - £400,000' },
    { min: 400001, max: 450000, label: '£400,001 - £450,000' },
    { min: 450001, max: 500000, label: '£450,001 - £500,000' },
    { min: 500001, max: 550000, label: '£500,001 - £550,000' },
    { min: 550001, max: 600000, label: '£550,001 - £600,000' },
    { min: 600001, max: 650000, label: '£600,001 - £650,000' },
    { min: 650001, max: 700000, label: '£650,001 - £700,000' },
    { min: 700001, max: 750000, label: '£700,001 - £750,000' },
    { min: 750001, max: 800000, label: '£750,001 - £800,000' },
    { min: 800001, max: 850000, label: '£800,001 - £850,000' },
    { min: 850001, max: 900000, label: '£850,001 - £900,000' },
    { min: 900001, max: 950000, label: '£900,001 - £950,000' },
    { min: 950001, max: 1000000, label: '£950,001 - £1,000,000' },
    { min: 1000001, max: 2000000, label: '£1,000,001 - £2,000,000' },
    { min: 2000001, max: 3000000, label: '£2,000,001 - £3,000,000' },
];
export default function Conveyancing() {
    const [isActive, setIsActive] = useState(true);
    const { title } = useParams();
    const navigate = useNavigate();
    const [feesData, setFeesData] = useState({
        sale: {},
        purchase: {},
        purchaseHMRCWholeTitle: {},
        purchaseHMRCPartTitle: {},
        remortgage: {},
        remortgageHMRCFee: {},
        transferOfEquity: {},
        transferOfEquityHMRCFee: {},
        firstRegistration: { legalFee: '', identityCheck: '', landRegistrySearch: '' },
        reviewLegalPack: { leaseholdFee: '', freeholdFee: '' },
        saleFixedFees: {
            leaseholdFee: '',
            mortgageAdminFee: '',
            telegraphicTransferFee: '',
            sharedOwnershipFee: '',
            auctionRepossessionFee: ''
        },
        saleDisbursements: {
            identityCheck: '',
            officialCopies: ''
        },
        purchaseFixedFees: {
            leaseholdFee: '',
            mortgageAdminFee: '',
            telegraphicTransferFee: '',
            helpToBuyISAFee: '',
            helpToBuyFee: '',
            rightToBuyFee: '',
            sharedOwnershipFee: '',
            newBuildFee: '',
            islamicMortgageFee: '',
            auctionRepossessionFee: '',
            giftedDepositFeeFirstGiftor: '',
            giftedDepositFeeAdditionalGiftors: '',
            buyToLetFee: '',
            arrangingIndemnityPolicy: '',
            landRegistrySearch: '',
            landChargesSearch: '',
            hmLandRegistryFee: ''
        },
        purchaseDisbursements: {
            identityCheck: '',
            searchPack: ''
        },
        remortgageFixedFees: {
            leaseholdFee: '',
            mortgageAdminFee: '',
            telegraphicTransferFee: '',
            buyToLetFee: '',
            landRegistrySearch: '',
            landChargesSearch: ''
        },
        remortgageDisbursements: {
            identityCheck: '',
            officialCopies: '',
            localSearchInsurance: ''
        },
        transferOfEquityFixedFees: {
            leaseholdFee: '',
            mortgageAdminFee: '',
            telegraphicTransferFee: '',
            landRegistrySearch: '',
            landChargesSearch: ''
        },
        transferOfEquityDisbursements: {
            identityCheck: '',
            localSearchInsurance: '',
            officialCopies: ''
        },
        mortgageRedemptionFixedFees: {
            legalFee: '',
            leaseholdFee: '',
            telegraphicTransferFee: ''
        },
        mortgageRedemptionDisbursements: {
            identityCheck: '',
            officialCopies: ''
        },
        firstRegistrationFees: {
            legalFee: '',
            identityCheck: '',
            landRegistrySearch: ''
        },
        reviewLegalPackFees: {
            leaseholdFee: '',
            freeholdFee: ''
        }
    });

    // Lead information state
    const [leadData, setLeadData] = useState({
        group_code: '',
        product_id: '',
        customer_ids: [],
        service_type: 'Purchase',
        property_address: {
            address1: '',
            address2: '',
            town: '',
            country: '',
            postcode: ''
        },
        property_value: '',
        completion_date: '',
        mortgage_lender: '',
        leasehold: false,
        new_build: false,
        shared_ownership: false,
        help_to_buy: false,
        acquisition: 'Inbound'
    });

    const handleToggle = () => {
        setIsActive(prev => !prev);
    };

    const [pages, setPages] = React.useState(2);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [customerList, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // Search states
    const [searchFields, setSearchFields] = useState({
        id: '',
        name: '',
        email: '',
        phone: '',
    });

    const authCtx = useContext(AuthContext);
    const debounceRef = useRef();

    const location = useLocation()
    // Try to read product_id and branch_id from navigation state first,
    // then from the URL query string so the page still works after refresh.
    const stateParams = location.state || {};
    const searchParams = new URLSearchParams(location.search || window.location.search);
    const product_id = stateParams.product_id || searchParams.get('product_id') || null;
    const branch_id = stateParams.branch_id || searchParams.get('branch_id') || null;
      const [editId, setEditId] = useState(null);


    

    // Fetch existing conveyancing cost data - Will.jsx pattern
    useEffect(() => {
        const fetchExistingConveycingCosts = async () => {
            try {
                const res = await postRequest('private/getConveycingCost', { branch_id, product_id }, authCtx.token);

                if (res?.data) {
                    setEditId(res?.data?._id);

                    // Helper function to convert array back to object format
                    const convertArrayToObject = (array) => {
                        const obj = {};
                        if (Array.isArray(array)) {
                            array.forEach(item => {
                                if (item.label && item.amount !== undefined) {
                                    obj[item.label] = item.amount.toString();
                                }
                            });
                        }
                        return obj;
                    };

                    // Update feesData with existing data
                    if (res.data.transactions && Array.isArray(res.data.transactions)) {
                        const newFeesData = { ...feesData };
                        
                        res.data.transactions.forEach(transaction => {
                            switch (transaction.transactionType) {
                                case 'Sale':
                                    newFeesData.sale = transaction.propertyValues || {};
                                    newFeesData.saleFixedFees = convertArrayToObject(transaction.fixedFees);
                                    newFeesData.saleDisbursements = convertArrayToObject(transaction.disbursements);
                                    break;
                                case 'Purchase':
                                    newFeesData.purchase = transaction.propertyValues || {};
                                    newFeesData.purchaseHMRCWholeTitle = transaction.hmrcWholeTitleFees || {};
                                    newFeesData.purchaseHMRCPartTitle = transaction.hmrcPartTitleFees || {};
                                    newFeesData.purchaseFixedFees = convertArrayToObject(transaction.fixedFees);
                                    newFeesData.purchaseDisbursements = convertArrayToObject(transaction.disbursements);
                                    break;
                                case 'Remortgage':
                                    newFeesData.remortgage = transaction.propertyValues || {};
                                    newFeesData.remortgageHMRCFee = transaction.hmrcFees || {};
                                    newFeesData.remortgageFixedFees = convertArrayToObject(transaction.fixedFees);
                                    newFeesData.remortgageDisbursements = convertArrayToObject(transaction.disbursements);
                                    break;
                                case 'Transfer_of_Equity':
                                    newFeesData.transferOfEquity = transaction.propertyValues || {};
                                    newFeesData.transferOfEquityHMRCFee = transaction.hmrcFees || {};
                                    newFeesData.transferOfEquityFixedFees = convertArrayToObject(transaction.fixedFees);
                                    newFeesData.transferOfEquityDisbursements = convertArrayToObject(transaction.disbursements);
                                    break;
                                case 'Mortgage_Redemption':
                                    newFeesData.mortgageRedemptionFixedFees = convertArrayToObject(transaction.fixedFees);
                                    newFeesData.mortgageRedemptionDisbursements = convertArrayToObject(transaction.disbursements);
                                    break;
                                case 'First_Registration':
                                    newFeesData.firstRegistrationFees = convertArrayToObject(transaction.fees);
                                    break;
                                case 'Review_Legal_Pack':
                                    newFeesData.reviewLegalPackFees = convertArrayToObject(transaction.fees);
                                    break;
                            }
                        });
                        
                        setFeesData(newFeesData);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch conveyancing cost data', error);
                // Don't show error for 404 - it means no data exists yet
               
            }
        };

        if (branch_id && product_id) fetchExistingConveycingCosts();
    }, [branch_id, product_id]);




    // Handle individual search input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchFields((prev) => ({ ...prev, [name]: value }));
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

  

    const [age, setAge] = React.useState('');
    const [status, setStatus] = React.useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleChange1 = (event) => {
        setStatus(event.target.value);
    };

    // Sale Transactions handlers
    const handleSalePropertyValueChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            sale: {
                ...prev.sale,
                [propertyRange]: value
            }
        }));
    };

    const handleSaleFixedFeesChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            saleFixedFees: {
                ...prev.saleFixedFees,
                [field]: value
            }
        }));
    };

    const handleSaleDisbursementsChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            saleDisbursements: {
                ...prev.saleDisbursements,
                [field]: value
            }
        }));
    };

    // Purchase Transactions handlers
    const handlePurchasePropertyValueChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            purchase: {
                ...prev.purchase,
                [propertyRange]: value
            }
        }));
    };

    const handlePurchaseHMRCWholeTitleChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            purchaseHMRCWholeTitle: {
                ...prev.purchaseHMRCWholeTitle,
                [propertyRange]: value
            }
        }));
    };

    const handlePurchaseHMRCPartTitleChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            purchaseHMRCPartTitle: {
                ...prev.purchaseHMRCPartTitle,
                [propertyRange]: value
            }
        }));
    };

    const handlePurchaseFixedFeesChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            purchaseFixedFees: {
                ...prev.purchaseFixedFees,
                [field]: value
            }
        }));
    };

    const handlePurchaseDisbursementsChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            purchaseDisbursements: {
                ...prev.purchaseDisbursements,
                [field]: value
            }
        }));
    };

    // Remortgage Transactions handlers
    const handleRemortgagePropertyValueChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            remortgage: {
                ...prev.remortgage,
                [propertyRange]: value
            }
        }));
    };

    const handleRemortgageHMRCFeeChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            remortgageHMRCFee: {
                ...prev.remortgageHMRCFee,
                [propertyRange]: value
            }
        }));
    };

    const handleRemortgageFixedFeesChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            remortgageFixedFees: {
                ...prev.remortgageFixedFees,
                [field]: value
            }
        }));
    };

    const handleRemortgageDisbursementsChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            remortgageDisbursements: {
                ...prev.remortgageDisbursements,
                [field]: value
            }
        }));
    };

    // Transfer of Equity handlers
    const handleTransferOfEquityPropertyValueChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            transferOfEquity: {
                ...prev.transferOfEquity,
                [propertyRange]: value
            }
        }));
    };

    const handleTransferOfEquityHMRCFeeChange = (propertyRange, value) => {
        setFeesData(prev => ({
            ...prev,
            transferOfEquityHMRCFee: {
                ...prev.transferOfEquityHMRCFee,
                [propertyRange]: value
            }
        }));
    };

    const handleTransferOfEquityFixedFeesChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            transferOfEquityFixedFees: {
                ...prev.transferOfEquityFixedFees,
                [field]: value
            }
        }));
    };

    const handleTransferOfEquityDisbursementsChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            transferOfEquityDisbursements: {
                ...prev.transferOfEquityDisbursements,
                [field]: value
            }
        }));
    };

    // Mortgage Redemption handlers
    const handleMortgageRedemptionFixedFeesChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            mortgageRedemptionFixedFees: {
                ...prev.mortgageRedemptionFixedFees,
                [field]: value
            }
        }));
    };

    const handleMortgageRedemptionDisbursementsChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            mortgageRedemptionDisbursements: {
                ...prev.mortgageRedemptionDisbursements,
                [field]: value
            }
        }));
    };

    // First Registration handlers
    const handleFirstRegistrationFeesChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            firstRegistrationFees: {
                ...prev.firstRegistrationFees,
                [field]: value
            }
        }));
    };

    // Review Legal Pack handlers
    const handleReviewLegalPackFeesChange = (field, value) => {
        setFeesData(prev => ({
            ...prev,
            reviewLegalPackFees: {
                ...prev.reviewLegalPackFees,
                [field]: value
            }
        }));
    };

    const handleSaveChanges = async () => {
        try {
            // Helper function to convert object to array format
            const convertFeesToArray = (feesObject, type) => {
                const feesArray = [];
                Object.entries(feesObject).forEach(([key, value]) => {
                    if (value && value.trim() !== '') {
                        feesArray.push({
                            label: key,
                            amount: parseFloat(value) || 0
                        });
                    }
                });
                return feesArray;
            };

            // Prepare transactions data from feesData
            const transactions = [
                {
                    transactionType: 'Sale',
                    propertyValues: feesData.sale,
                    fixedFees: convertFeesToArray(feesData.saleFixedFees, 'fixed'),
                    disbursements: convertFeesToArray(feesData.saleDisbursements, 'disbursement')
                },
                {
                    transactionType: 'Purchase',
                    propertyValues: feesData.purchase,
                    hmrcWholeTitleFees: feesData.purchaseHMRCWholeTitle,
                    hmrcPartTitleFees: feesData.purchaseHMRCPartTitle,
                    fixedFees: convertFeesToArray(feesData.purchaseFixedFees, 'fixed'),
                    disbursements: convertFeesToArray(feesData.purchaseDisbursements, 'disbursement')
                },
                {
                    transactionType: 'Remortgage',
                    propertyValues: feesData.remortgage,
                    hmrcFees: feesData.remortgageHMRCFee,
                    fixedFees: convertFeesToArray(feesData.remortgageFixedFees, 'fixed'),
                    disbursements: convertFeesToArray(feesData.remortgageDisbursements, 'disbursement')
                },
                {
                    transactionType: 'Transfer_of_Equity',
                    propertyValues: feesData.transferOfEquity,
                    hmrcFees: feesData.transferOfEquityHMRCFee,
                    fixedFees: convertFeesToArray(feesData.transferOfEquityFixedFees, 'fixed'),
                    disbursements: convertFeesToArray(feesData.transferOfEquityDisbursements, 'disbursement')
                },
                {
                    transactionType: 'Mortgage_Redemption',
                    fixedFees: convertFeesToArray(feesData.mortgageRedemptionFixedFees, 'fixed'),
                    disbursements: convertFeesToArray(feesData.mortgageRedemptionDisbursements, 'disbursement')
                },
                {
                    transactionType: 'First_Registration',
                    fees: convertFeesToArray(feesData.firstRegistrationFees, 'fee')
                },
                {
                    transactionType: 'Review_Legal_Pack',
                    fees: convertFeesToArray(feesData.reviewLegalPackFees, 'fee')
                }
            ];

            // Prepare the data for createConveycingCost API
            const requestData = {
               product_id,
                  branch_id,
                transactions: transactions
            };

            console.log(requestData , 'requestData@123')

            // Will.jsx pattern - check editId for create vs edit
            let res;
            console.log(editId , 'editId@123')
            if (editId) {
                res = await postRequest(`private/editConveycingCost/${editId}`, requestData, authCtx.token);
            } else {
                res = await postRequest(`private/createConveycingCost`, requestData, authCtx.token);
            }
            
            if (res?.status === 200) {
                Swal.fire('Success', res.message || 'Conveyancing cost saved!', 'success');
                navigate(-1);
            } else {
                Swal.fire('Error', res?.message || 'Failed to save conveyancing cost.', 'error');
            }
        } catch (err) {
            Swal.fire('Error', 'Something went wrong!', 'error');
        }
    };





    const [personName, setPersonName] = React.useState([]);
const slugToTitle = (slug) => {
  return slug
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

  const readableTitle = slugToTitle(title || '');
    return (
        <>
            <div className='page-header pb-3'>
                <Typography variant="h5" fontWeight="600" mb={2}>
                       Manage {readableTitle}
                     </Typography>
                <div className='conveyancing-toggle mb-3'>
                    <div className='d-flex align-items-center'>
                        <FiberManualRecordIcon 
                            className={isActive ? 'text-success' : 'text-danger'} 
                            style={{ fontSize: '16px', marginRight: '8px' }}
                        />
                        <Typography variant="body1" style={{ marginRight: '10px' }}>
                            Conveyancing Enabled?
                        </Typography>
                        <div
                            className={`toggle-switch ${isActive ? 'active' : ''}`}
                            onClick={handleToggle}
                            style={{
                                width: '50px',
                                height: '25px',
                                backgroundColor: isActive ? '#4caf50' : '#f44336',
                                borderRadius: '15px',
                                position: 'relative',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s'
                            }}
                        >
                            <div 
                                style={{
                                    width: '21px',
                                    height: '21px',
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    top: '2px',
                                    left: isActive ? '27px' : '2px',
                                    transition: 'left 0.3s'
                                }}
                            />
                        </div>
                    </div>
                </div>
                {/* <div className='header-right-btn'>
          <Stack spacing={2} direction="row">
            <Button variant="outlined" className='red-outline-btn text-capitalize'>
              <NavLink to="/customers/create" className="red-link-text">
                <SearchIcon /> &nbsp; Search Customers
              </NavLink>
            </Button>
            <Button variant="outlined" className='red-outline-btn text-capitalize'>
              <NavLink to="/customers/create" className="red-link-text">
                <PersonAddOutlinedIcon /> &nbsp; Create Customer
              </NavLink>
            </Button>
          </Stack>
        </div> */}
            </div>

            {/* Search Form */}
            {isActive && (
            <div className='page-top-formview mb-3'>
                <Row>
                    <Col sm={12}>
                        <div className='customer-tab-view mb-4'>
                            <Table responsive bordered component="div" className='m-0'
                                count={100}
                                page={page}
                            >
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>Sale Transactions</th>

                                    </tr>

                                </thead>
                               
                            </Table>
                            <Row className='custom-p'>
                                <Col sm={4}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Property Value</th>
                                                <th>Legal Fee (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {propertyValueRanges.map((range, index) => (
                                                <tr key={index}>
                                                    <td>{range.label}</td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.sale[range.label] || ''}
                                                            onChange={(e) => handleSalePropertyValueChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={4}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Fixed Fees</th>
                                                <th>Amount (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Leasehold Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.saleFixedFees.leaseholdFee}
                                                        onChange={(e) => handleSaleFixedFeesChange('leaseholdFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Mortgage Admin Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.saleFixedFees.mortgageAdminFee}
                                                        onChange={(e) => handleSaleFixedFeesChange('mortgageAdminFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Telegraphic Transfer (TT) Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.saleFixedFees.telegraphicTransferFee}
                                                        onChange={(e) => handleSaleFixedFeesChange('telegraphicTransferFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Shared Ownership Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.saleFixedFees.sharedOwnershipFee}
                                                        onChange={(e) => handleSaleFixedFeesChange('sharedOwnershipFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Auction / Repossession Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.saleFixedFees.auctionRepossessionFee}
                                                        onChange={(e) => handleSaleFixedFeesChange('auctionRepossessionFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={4}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Disbursements</th>
                                                <th>Amount (inc VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Identity Check</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.saleDisbursements.identityCheck}
                                                        onChange={(e) => handleSaleDisbursementsChange('identityCheck', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Official Copies</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.saleDisbursements.officialCopies}
                                                        onChange={(e) => handleSaleDisbursementsChange('officialCopies', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>

                            </Row>

                        </div>
                         <div className='customer-tab-view mb-4'>
                            <Table responsive bordered component="div" className='m-0'
                                count={100}
                                page={page}
                            >
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>Purchase Transactions</th>

                                    </tr>

                                </thead>
                              
                            </Table>
                            <Row className='custom-p'>
                                <Col sm={5}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th rowSpan={2}>Property Value</th>
                                                <th rowSpan={2}>Legal Fee (ex VAT)</th>
                                                <th colSpan={2}>HMRC Land Reg Fee</th>
                                            </tr>
                                            <tr>
                                                <th>Whole Title</th>
                                                <th>Part Title</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {propertyValueRanges.map((range, index) => (
                                                <tr key={index}>
                                                    <td>{range.label}</td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.purchase[range.label] || ''}
                                                            onChange={(e) => handlePurchasePropertyValueChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.purchaseHMRCWholeTitle[range.label] || ''}
                                                            onChange={(e) => handlePurchaseHMRCWholeTitleChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.purchaseHMRCPartTitle[range.label] || ''}
                                                            onChange={(e) => handlePurchaseHMRCPartTitleChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={7}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Fixed Fees</th>
                                                <th>Amount (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Leasehold Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.leaseholdFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('leaseholdFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Mortgage Admin Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.mortgageAdminFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('mortgageAdminFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Telegraphic Transfer (TT) Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.telegraphicTransferFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('telegraphicTransferFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Help to Buy ISA Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.helpToBuyISAFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('helpToBuyISAFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Help to Buy Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.helpToBuyFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('helpToBuyFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Right to Buy Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.rightToBuyFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('rightToBuyFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Shared Ownership Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.sharedOwnershipFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('sharedOwnershipFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>New Build Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.newBuildFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('newBuildFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Islamic Mortgage Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.islamicMortgageFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('islamicMortgageFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Auction / Repossession Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.auctionRepossessionFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('auctionRepossessionFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Gifted Deposit Fee (1st Giftor)</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.giftedDepositFeeFirstGiftor}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('giftedDepositFeeFirstGiftor', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Gifted Deposit Fee (Additional Giftors)</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.giftedDepositFeeAdditionalGiftors}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('giftedDepositFeeAdditionalGiftors', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Buy to Let Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.buyToLetFee}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('buyToLetFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Arranging an Indemnity Policy</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.arrangingIndemnityPolicy}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('arrangingIndemnityPolicy', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Land Registry Search</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.landRegistrySearch}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('landRegistrySearch', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Land Charges Search</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseFixedFees.landChargesSearch}
                                                        onChange={(e) => handlePurchaseFixedFeesChange('landChargesSearch', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Disbursements</th>
                                                <th>Amount (inc VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Identity Check</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseDisbursements.identityCheck}
                                                        onChange={(e) => handlePurchaseDisbursementsChange('identityCheck', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Search Pack - Local Authority, Water & Draingage, Environmental Search (FCI Premium)</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.purchaseDisbursements.searchPack}
                                                        onChange={(e) => handlePurchaseDisbursementsChange('searchPack', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>

                            </Row>

                        </div>
                         <div className='customer-tab-view mb-4'>
                            <Table responsive bordered component="div" className='m-0'
                                count={100}
                                page={page}
                            >
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>Remortgage Transactions</th>

                                    </tr>

                                </thead>
                                {/* <tbody>
                                    <tr>
                                        <td><CheckIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CloseIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CheckIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CloseIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CheckIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CloseIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CheckIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CloseIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CheckIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td><CloseIcon /> &nbsp; Quotes / Revise Quote</td>

                                        <td>
                                            <Tooltip title="Manage"> <span className="red-link-text">Manage</span></Tooltip>
                                            &nbsp;&nbsp; | &nbsp;&nbsp;
                                            <Tooltip title="View Lead"><NavLink to={'/#'} className="red-link-text">Search Leads</NavLink></Tooltip>

                                        </td>
                                    </tr>


                                </tbody> */}
                            </Table>
                            <Row className='custom-p'>
                                <Col sm={4}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Property Value</th>
                                                <th>Legal Fee (ex VAT)</th>
                                                <th>HMRC Land Reg Fee</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {propertyValueRanges.map((range, index) => (
                                                <tr key={index}>
                                                    <td>{range.label}</td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.remortgage[range.label] || ''}
                                                            onChange={(e) => handleRemortgagePropertyValueChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.remortgageHMRCFee[range.label] || ''}
                                                            onChange={(e) => handleRemortgageHMRCFeeChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={8}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Fixed Fees</th>
                                                <th>Amount (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Leasehold Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageFixedFees.leaseholdFee}
                                                        onChange={(e) => handleRemortgageFixedFeesChange('leaseholdFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Mortgage Admin Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageFixedFees.mortgageAdminFee}
                                                        onChange={(e) => handleRemortgageFixedFeesChange('mortgageAdminFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Telegraphic Transfer (TT) Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageFixedFees.telegraphicTransferFee}
                                                        onChange={(e) => handleRemortgageFixedFeesChange('telegraphicTransferFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Buy to Let Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageFixedFees.buyToLetFee}
                                                        onChange={(e) => handleRemortgageFixedFeesChange('buyToLetFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Land Registry Search</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageFixedFees.landRegistrySearch}
                                                        onChange={(e) => handleRemortgageFixedFeesChange('landRegistrySearch', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Land Charges Search</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageFixedFees.landChargesSearch}
                                                        onChange={(e) => handleRemortgageFixedFeesChange('landChargesSearch', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Disbursements</th>
                                                <th>Amount (inc VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Identity Check</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageDisbursements.identityCheck}
                                                        onChange={(e) => handleRemortgageDisbursementsChange('identityCheck', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Official Copies</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageDisbursements.officialCopies}
                                                        onChange={(e) => handleRemortgageDisbursementsChange('officialCopies', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Local Search Insurance</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.remortgageDisbursements.localSearchInsurance}
                                                        onChange={(e) => handleRemortgageDisbursementsChange('localSearchInsurance', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>

                            </Row>

                        </div>
                         <div className='customer-tab-view mb-4'>
                            <Table responsive bordered component="div" className='m-0'
                                count={100}
                                page={page}
                            >
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>Transfer of Equity Transactions</th>

                                    </tr>

                                </thead>
                                
                            </Table>
                            <Row className='custom-p'>
                                <Col sm={4}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Property Value</th>
                                                <th>Legal Fee (ex VAT)</th>
                                                <th>HMRC Land Reg Fee</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {propertyValueRanges.map((range, index) => (
                                                <tr key={index}>
                                                    <td>{range.label}</td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.transferOfEquity[range.label] || ''}
                                                            onChange={(e) => handleTransferOfEquityPropertyValueChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                    <td className='p-0'>
                                                        <Form.Control
                                                            type="number"
                                                            aria-describedby="passwordHelpBlock"
                                                            value={feesData.transferOfEquityHMRCFee[range.label] || ''}
                                                            onChange={(e) => handleTransferOfEquityHMRCFeeChange(range.label, e.target.value)}
                                                            className='border-0'
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={8}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Fixed Fees</th>
                                                <th>Amount (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Leasehold Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityFixedFees.leaseholdFee}
                                                        onChange={(e) => handleTransferOfEquityFixedFeesChange('leaseholdFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Mortgage Admin Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityFixedFees.mortgageAdminFee}
                                                        onChange={(e) => handleTransferOfEquityFixedFeesChange('mortgageAdminFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Telegraphic Transfer (TT) Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityFixedFees.telegraphicTransferFee}
                                                        onChange={(e) => handleTransferOfEquityFixedFeesChange('telegraphicTransferFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Land Registry Search</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityFixedFees.landRegistrySearch}
                                                        onChange={(e) => handleTransferOfEquityFixedFeesChange('landRegistrySearch', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Land Charges Search</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityFixedFees.landChargesSearch}
                                                        onChange={(e) => handleTransferOfEquityFixedFeesChange('landChargesSearch', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Disbursements</th>
                                                <th>Amount (inc VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Identity Check</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityDisbursements.identityCheck}
                                                        onChange={(e) => handleTransferOfEquityDisbursementsChange('identityCheck', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Local Search Insurance</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityDisbursements.localSearchInsurance}
                                                        onChange={(e) => handleTransferOfEquityDisbursementsChange('localSearchInsurance', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Official Copies</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.transferOfEquityDisbursements.officialCopies}
                                                        onChange={(e) => handleTransferOfEquityDisbursementsChange('officialCopies', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>

                            </Row>

                        </div>
                         <div className='customer-tab-view mb-4'>
                            <Table responsive bordered component="div" className='m-0'
                                count={100}
                                page={page}
                            >
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>Mortgage Redemption Transactions</th>

                                    </tr>

                                </thead>
                              
                            </Table>
                            <Row className='custom-p'>
                                <Col sm={6}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Fixed Fees</th>
                                                <th>Amount (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Legal Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.mortgageRedemptionFixedFees.legalFee || ''}
                                                        onChange={(e) => handleMortgageRedemptionFixedFeesChange('legalFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Leasehold Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.mortgageRedemptionFixedFees.leaseholdFee || ''}
                                                        onChange={(e) => handleMortgageRedemptionFixedFeesChange('leaseholdFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Telegraphic Transfer (TT) Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.mortgageRedemptionFixedFees.telegraphicTransferFee || ''}
                                                        onChange={(e) => handleMortgageRedemptionFixedFeesChange('telegraphicTransferFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={6}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Disbursements</th>
                                                <th>Amount (inc VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Identity Check</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.mortgageRedemptionDisbursements.identityCheck || ''}
                                                        onChange={(e) => handleMortgageRedemptionDisbursementsChange('identityCheck', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Official Copies</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.mortgageRedemptionDisbursements.officialCopies || ''}
                                                        onChange={(e) => handleMortgageRedemptionDisbursementsChange('officialCopies', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>

                            </Row>

                        </div>
                         <div className='customer-tab-view mb-4'>
                            <Table responsive bordered component="div" className='m-0'
                                count={100}
                                page={page}
                            >
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>First Registration Transactions</th>

                                    </tr>

                                </thead>
                               
                            </Table>
                            <Row className='custom-p'>
                                <Col sm={6}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Fixed Fees</th>
                                                <th>Amount (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Legal Fee</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.firstRegistrationFees.legalFee}
                                                        onChange={(e) => handleFirstRegistrationFeesChange('legalFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={6}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Disbursements</th>
                                                <th>Amount (inc VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Identity Check</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.firstRegistrationFees.identityCheck}
                                                        onChange={(e) => handleFirstRegistrationFeesChange('identityCheck', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Land Registry Search</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.firstRegistrationFees.landRegistrySearch}
                                                        onChange={(e) => handleFirstRegistrationFeesChange('landRegistrySearch', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                
                            </Row>

                        </div>
                         <div className='customer-tab-view mb-4'>
                            <Table responsive bordered component="div" className='m-0'
                                count={100}
                                page={page}
                            >
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>Review of Legal Pack Transactions</th>

                                    </tr>

                                </thead>
                                
                            </Table>
                            <Row className='custom-p'>
                                <Col sm={12}>
                                    <Table responsive bordered component="div"
                                        count={100}
                                        page={page}
                                        className='second-col-w-200'
                                    ><thead>
                                            <tr>
                                                <th>Fixed Fees</th>
                                                <th>Amount (ex VAT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Legal Fee (Leasehold)</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.reviewLegalPackFees.leaseholdFee}
                                                        onChange={(e) => handleReviewLegalPackFeesChange('leaseholdFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Legal Fee (Freehold)</td>
                                                <td className='p-0'>
                                                    <Form.Control
                                                        type="number"
                                                        aria-describedby="passwordHelpBlock"
                                                        value={feesData.reviewLegalPackFees.freeholdFee}
                                                        onChange={(e) => handleReviewLegalPackFeesChange('freeholdFee', e.target.value)}
                                                        className='border-0'
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            

                            </Row>

                        </div>
                    </Col>
                     <Col sm={12}> 
 <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={()=>navigate(-1)} >
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' onClick={handleSaveChanges}>
              Submit
            </Button>
          </Stack></Col>

                </Row>




            </div>
            )}

            {/* Table View */}
            <div>


                {/* Pagination */}
                {customerList.length > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                            shape="rounded"
                            size="medium"
                            sx={{
                                '& .Mui-selected': {
                                    backgroundColor: '#bb0000 !important',
                                    color: '#fff !important',
                                },
                                '& .MuiPaginationItem-root': {
                                    color: '#bb0000',
                                    borderColor: '#bb0000',
                                },
                            }}
                        />
                    </div>
                )}
            </div>
        </>
    );
}
